import { render } from "./TheResolutionArea.vue?vue&type=template&id=b6ff09fc&scoped=true&ts=true"
import script from "./TheResolutionArea.vue?vue&type=script&lang=ts"
export * from "./TheResolutionArea.vue?vue&type=script&lang=ts"

import "./TheResolutionArea.vue?vue&type=style&index=0&id=b6ff09fc&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ff09fc"]])

export default __exports__